<div class="mt-2 monitor-device-system-wrapper panel" *ngIf="_device && !isShowDnsWatch">
    <div class="mt-4">
        <span class="pointer vhub-vce-btn" *ngIf="showNote">
            Attack Shield License not selected - please select and subscribe if required.
        </span>
        <mat-tab-group animationDuration="0ms" >          
            <mat-tab label="States">
                <hr class="y-border" />
                <!-- <table mat-table [dataSource]="_dataSource" multiTemplateDataRows class="mat-elevation-z8"> -->
                    <table mat-table [dataSource]="_dataSource" multiTemplateDataRows class="mat-elevation-z8 w-100 d-md-table d-block overflow-auto" matSort
        (matSortChange)="sortData($event)">
                    <ng-container matColumnDef="expand">
                        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                        <td mat-cell *matCellDef="let element">
                        <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">                       
                            <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>                       
                            <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>                        
                        </button>
                        </td>
                    </ng-container>
                    <ng-container *ngFor="let column of displayedColumns; index as i" matColumnDef="{{column}}">
                        <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                        <td mat-cell *matCellDef="let element" [ngClass]="stateColor(element.state)"> 
                            <ng-template [ngIf]="column == 'Date'">{{ element.date }}</ng-template>
                            <ng-template [ngIf]="column == 'State'">{{ element.state }}</ng-template>
                            <ng-template [ngIf]="column == 'Flow Total'">{{ element.flowTotal }}</ng-template>
                            <ng-template [ngIf]="column == 'Flow Use %'">{{ element.flowUse }}</ng-template>
                            <ng-template [ngIf]="column == 'Trouble Strays %'">{{ element.troublePkts }}</ng-template>
                            <ng-template [ngIf]="column == 'Trble Disjointed %'">{{ element.trblDisjointed }}</ng-template>
                            <ng-template [ngIf]="column == 'Max Disjointed %'">{{ element.maxDisjointed }}</ng-template>
                            <ng-template [ngIf]="column == 'Disjointed'">{{ element.disjointed }}</ng-template>
                            <ng-template [ngIf]="column == 'Strays'">{{ element.strays }}</ng-template>
                            <ng-template [ngIf]="column == 'UniqueIPs'">{{ element.uniqueIps }}</ng-template>
                            <ng-template [ngIf]="column == 'Action'">{{ element.action }}</ng-template>
                        </td>
                    </ng-container>
                     <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                   <ng-container matColumnDef="expandedDetail">
                        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                        <div class="example-element-detail"
                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            <table>
                                <tr>
                                    <th>Link</th>
                                    <th>Iface</th>
                                    <th>RX</th>
                                    <th>TX</th>
                                </tr>
                                <tr *ngFor="let l of element.links">
                                    <td>{{l.link}}</td>
                                    <td>{{l.iface}}</td>
                                    <td>{{l.rx}}</td>
                                    <td>{{l.tx}}</td>
                                </tr>
                            </table>
                        </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
                    <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"
                        class="example-element-row"
                        [class.example-expanded-row]="expandedElement === element"
                        (click)="expandedElement = expandedElement === element ? null : element">
                    </tr>
                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> 
                    </table>
                    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent = $event" (page)="handlePageEvent($event)" [hidden]="!selfSort && !length">
                </mat-paginator>
            </mat-tab>
              <!-- (selectedTabChange)="selectedTabChange($event)"
        [selectedIndex]="selectedTabIndex" -->
            <mat-tab label="Config">
                <hr class="y-border" />
                <table>
                    <tbody>
                        <tr>
                            <th>State</th>
                            <th>Status</th>                            
                            <th>Sensitivity</th>
                            <th>Log Size</th>
                            <th>State Log Size</th>
                            <th>Max Flows</th>
                            <th>Flows in Use</th>
                            <th>Strays</th>
                        </tr>
                        <tr [ngClass]="stateColor(state)">
                            <td>{{ flowdoscheck_state?.STATE || "" }}</td>
                            <td>{{ formatEnabled(flowdoscheck_state?.status || "") }}</td>
                            <td>{{ flowdoscheck_config?.mode || "" }}</td>
                            <td>{{ flowdoscheck_config?.log_size || "" }}</td>
                            <td>{{ flowdoscheck_config?.state_log_size || "" }}</td>
                            <td>{{ flowdoscheck_stat?.MaxFlows || "" }}</td>
                            <td>{{ flowdoscheck_stat?.FlowUsePct || "" }}</td>
                            <td>{{ flowdoscheck_stat?.StraysPct || "" }}</td>
                        </tr>                                             
                    </tbody>
                </table>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>

<div class="mt-2 monitor-device-system-wrapper panel" *ngIf="_device && isShowDnsWatch">    
     <div class="attack-shield-header" style="display: flex; align-items: center; margin: 16px;">
        <img src="./assets/images/Shield-XDR-icon.png" alt="Attack Shield Logo" style="height: 32px; margin: 16px 16px 0 0;" />
        <h3 style="margin: 16px 0 0 0;">Attack Shield</h3>
    </div>
    <div class="mt-4">
        <span class="pointer vhub-vce-btn" *ngIf="showNote">
            Attack Shield License not selected - please select and subscribe if required.
        </span>
        <mat-tab-group animationDuration="0ms" class="main-tab-xdr">
            <mat-tab label="MonitorFlow">
                <app-device-xdr-monitorflow [deviceId]="deviceId"></app-device-xdr-monitorflow>
            </mat-tab>
            <mat-tab label="XDR Top 10 Blocked">
                <app-device-xdr-top10-blocked [deviceId]="deviceId" [xdrInfo_5m]="xdrInfo_5m"> </app-device-xdr-top10-blocked>
            </mat-tab>
            <mat-tab label="Detail">
                <div class="pt-4" class="div-wrapper">
                    <section class="example-section">
                        <span class="example-margin">DOS/DDOS</span>
                        <hr class="y-border" />
                        <mat-tab-group animationDuration="0ms" class="sub-tab-xdr">
                            <mat-tab label="Detail">
                                <table>
                                <tbody>
                                    <tr>
                                        <th>State</th>
                                        <th>Status</th>                            
                                        <th>Sensitivity</th>
                                        <th>Log Size</th>
                                        <th>State Log Size</th>
                                        <th>Max Flows</th>
                                        <th>Flows in Use</th>
                                        <th>Strays</th>
                                    </tr>
                                    <tr [ngClass]="stateColor(state)">
                                        <td>{{ flowdoscheck_state?.STATE || "" }}</td>
                                        <td>{{ formatEnabled(flowdoscheck_state?.status || "") }}</td>                            
                                        <td>{{ flowdoscheck_config?.mode || "" }}</td>
                                        <td>{{ flowdoscheck_config?.log_size || "" }}</td>
                                        <td>{{ flowdoscheck_config?.state_log_size || "" }}</td>
                                        <td>{{ flowdoscheck_stat?.MaxFlows || "" }}</td>
                                        <td>{{ flowdoscheck_stat?.FlowUsePct || "" }}</td>
                                        <td>{{ flowdoscheck_stat?.StraysPct || "" }}</td>
                                    </tr>                                             
                                </tbody>
                            </table>
                            </mat-tab>
                            <mat-tab label="Report">
                                <hr class="y-border" />                       
                                <table mat-table 
                                    [dataSource]="_dataSource" 
                                    multiTemplateDataRows 
                                    class="mat-elevation-z8 w-100 d-md-table d-block overflow-auto" 
                                    matSort
                                    (matSortChange)="sortData($event)">
                                    <ng-container matColumnDef="expand">
                                        <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                                        <td mat-cell *matCellDef="let element">
                                        <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">                       
                                            <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>                       
                                            <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>                        
                                        </button>
                                        </td>
                                    </ng-container>
                                    <ng-container *ngFor="let column of displayedColumns; index as i" matColumnDef="{{column}}">
                                        <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                                        <td mat-cell *matCellDef="let element" [ngClass]="stateColor(element.state)"> 
                                            <ng-template [ngIf]="column == 'Date'">{{ element.date }}</ng-template>
                                            <ng-template [ngIf]="column == 'State'">{{ element.state }}</ng-template>
                                            <ng-template [ngIf]="column == 'Flow Total'">{{ element.flowTotal }}</ng-template>
                                            <ng-template [ngIf]="column == 'Flow Use %'">{{ element.flowUse }}</ng-template>
                                            <ng-template [ngIf]="column == 'Trouble Strays %'">{{ element.troublePkts }}</ng-template>
                                            <ng-template [ngIf]="column == 'Trble Disjointed %'">{{ element.trblDisjointed }}</ng-template>
                                            <ng-template [ngIf]="column == 'Max Disjointed %'">{{ element.maxDisjointed }}</ng-template>
                                            <ng-template [ngIf]="column == 'Disjointed'">{{ element.disjointed }}</ng-template>
                                            <ng-template [ngIf]="column == 'Strays'">{{ element.strays }}</ng-template>
                                            <ng-template [ngIf]="column == 'UniqueIPs'">{{ element.uniqueIps }}</ng-template>
                                            <ng-template [ngIf]="column == 'Action'">{{ element.action }}</ng-template>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="expandedDetail">
                                        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                                        <div class="example-element-detail"
                                            [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                                            <table>
                                                <tr>
                                                    <th>Link</th>
                                                    <th>Iface</th>
                                                    <th>RX</th>
                                                    <th>TX</th>
                                                </tr>
                                                <tr *ngFor="let l of element.links">
                                                    <td>{{l.link}}</td>
                                                    <td>{{l.iface}}</td>
                                                    <td>{{l.rx}}</td>
                                                    <td>{{l.tx}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
                                    <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;"
                                        class="example-element-row"
                                        [class.example-expanded-row]="expandedElement === element"
                                        (click)="expandedElement = expandedElement === element ? null : element">
                                    </tr>
                                    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> 
                                </table>
                                <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                                (page)="pageEvent = $event" (page)="handlePageEvent($event)" [hidden]="!selfSort && !length">
                                </mat-paginator>
                            </mat-tab>
                        </mat-tab-group>                           
                    </section> 
                    <section class="example-section">
                        <span class="example-margin">Attack Shield System Protection Rules</span>
                        <hr class="y-border" />        
                        <table mat-table [dataSource]="ashield_rule" class="mat-elevation-z8 custom">
                            
                            <ng-container matColumnDef="packet">
                                <th mat-header-cell *matHeaderCellDef> Packets </th>
                                <td mat-cell *matCellDef="let element">{{ element.packet  }}</td>
                            </ng-container>

                            <ng-container matColumnDef="byte">
                                <th mat-header-cell *matHeaderCellDef> Bytes </th>
                                <td mat-cell *matCellDef="let element">{{ element.byte }}</td>
                            </ng-container>

                            <ng-container matColumnDef="target">
                                <th mat-header-cell *matHeaderCellDef> Target </th>
                                <td mat-cell *matCellDef="let element">{{ element.target }}</td>
                            </ng-container>

                            <ng-container matColumnDef="protocol">
                                <th mat-header-cell *matHeaderCellDef> Prot </th>
                                <td mat-cell *matCellDef="let element">{{ element.protocol  }}</td>
                            </ng-container>

                            <ng-container matColumnDef="section">
                                <th mat-header-cell *matHeaderCellDef> Section </th>
                                <td mat-cell *matCellDef="let element">{{ element.section }}</td>
                            </ng-container>

                            <ng-container matColumnDef="description">
                                <th mat-header-cell *matHeaderCellDef> Description </th>
                                <td mat-cell *matCellDef="let element">{{ element.description }}</td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="['packet','byte','target','protocol','section','description']"></tr>
                            <tr mat-row *matRowDef="let row; columns: ['packet','byte','target','protocol','section','description'];"></tr>
                        </table>
                    </section>
                    <section class="example-section">
                        <span class="example-margin">XDR Stat</span>
                        <hr class="y-border" />
                            <mat-tab-group animationDuration="0ms" class="sub-tab-xdr">
                                <mat-tab label="Attack Stat">
                                    <hr class="y-border" />
                                    <span>Selected Profile: {{ getSelectedThreatFeedProfile(0) }}</span>
                                    <table mat-table [dataSource]="_attackDataSource" class="mat-elevation-z8 w-100 d-md-table d-block overflow-auto custom" matSort (matSortChange)="attackSortData($event)">

                                        <ng-container *ngFor="let column of xdrDisplayedColumns; trackBy: trackByFn" [matColumnDef]="column">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="xdrColumnWidths[column]">{{ column }}</th>
                                            <td mat-cell *matCellDef="let element" [style.width]="xdrColumnWidths[column]">
                                            <ng-container [ngSwitch]="column">
                                                <span *ngSwitchCase="'Source IP'">
                                                {{ element.payload?.src ? element.payload.src : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'Source Name'">
                                                {{ element.payload?.src_name ? element.payload.src_name : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'MAC'">
                                                {{ element.payload?.mac ? element.payload.mac : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'Destination IP'">
                                                {{ element.payload?.dst ? element.payload.dst : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'Destination Name'">
                                                {{ element.payload?.dst_name ? element.payload.dst_name : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'Protocol'">
                                                {{ element.payload?.proto_name ? element.payload.proto_name : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'Packet'">
                                                {{ element.payload?.pkt ? element.payload.pkt : 0 }}
                                                </span>

                                                <span *ngSwitchCase="'Bytes'">
                                                {{ element.payload?.byte ? element.payload.byte : 0 }}
                                                </span>

                                                <span *ngSwitchCase="'Iface'">
                                                {{ element.payload?.in_if ? element.payload.in_if :
                                                    (element.payload?.out_if ? element.payload.out_if : '-') }}
                                                </span>

                                                <span *ngSwitchCase="'Timestamp'">
                                                {{ formatDate(element.ts) }}
                                                </span>

                                                <span *ngSwitchDefault>-</span>
                                            </ng-container>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="xdrDisplayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: xdrDisplayedColumns;"></tr>

                                    </table>

                                    <mat-paginator
                                    [length]="attackLength"
                                    [pageSize]="attackPageSize"
                                    [pageSizeOptions]="attackPageSizeOptions"
                                    (page)="handleAttackPageEvent($event)"
                                    [hidden]="!attackSelfSort && !attackLength">
                                    </mat-paginator>

                                </mat-tab> 

                                <mat-tab label="Spam Stat">
                                    <hr class="y-border" />
                                        <span>Selected Profile: {{ getSelectedThreatFeedProfile(1) }}</span>
                                        <table mat-table [dataSource]="_spamDataSource" class="mat-elevation-z8 w-100 d-md-table d-block overflow-auto custom" matSort (matSortChange)="spamSortData($event)">
                                            
                                            <ng-container *ngFor="let column of xdrDisplayedColumns; trackBy: trackByFn" [matColumnDef]="column">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="xdrColumnWidths[column]">{{ column }}</th>
                                                <td mat-cell *matCellDef="let element" [style.width]="xdrColumnWidths[column]">
                                                <ng-container [ngSwitch]="column">
                                                    <span *ngSwitchCase="'Source IP'">
                                                {{ element.payload?.src ? element.payload.src : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'Source Name'">
                                                {{ element.payload?.src_name ? element.payload.src_name : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'MAC'">
                                                {{ element.payload?.mac ? element.payload.mac : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'Destination IP'">
                                                {{ element.payload?.dst ? element.payload.dst : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'Destination Name'">
                                                {{ element.payload?.dst_name ? element.payload.dst_name : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'Protocol'">
                                                {{ element.payload?.proto_name ? element.payload.proto_name : '-' }}
                                                </span>

                                                <span *ngSwitchCase="'Packet'">
                                                {{ element.payload?.pkt ? element.payload.pkt : 0 }}
                                                </span>

                                                <span *ngSwitchCase="'Bytes'">
                                                {{ element.payload?.byte ? element.payload.byte : 0 }}
                                                </span>

                                                <span *ngSwitchCase="'Iface'">
                                                {{ element.payload?.in_if ? element.payload.in_if :
                                                    (element.payload?.out_if ? element.payload.out_if : '-') }}
                                                </span>

                                                <span *ngSwitchCase="'Timestamp'">
                                                {{ formatDate(element.ts) }}
                                                </span>
                                                    <span *ngSwitchDefault>-</span>
                                                </ng-container>
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="xdrDisplayedColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: xdrDisplayedColumns;"></tr>
                                        </table>
                                        <mat-paginator
                                            [length]="spamLength"
                                            [pageSize]="spamPageSize"
                                            [pageSizeOptions]="spamPageSizeOptions"
                                            (page)="handleSpamPageEvent($event)"
                                            [hidden]="!spamSelfSort && !spamLength">
                                        </mat-paginator>
                                </mat-tab>

                                <mat-tab label="GeoIP Stat">
                                    <hr class="y-border" />
                                        <table mat-table [dataSource]="_geoipDataSource" class="mat-elevation-z8 w-100 d-md-table d-block overflow-auto custom" matSort (matSortChange)="geoipSortData($event)">
                                            
                                            <ng-container *ngFor="let column of xdrDisplayedColumns; trackBy: trackByFn" [matColumnDef]="column">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width]="geoipColumnWidths[column]">{{ column }}</th>
                                                <td mat-cell *matCellDef="let element" [style.width]="geoipColumnWidths[column]">
                                                <ng-container [ngSwitch]="column">
                                                    <span *ngSwitchCase="'Source IP'">
                                                    {{ element.payload?.src ? element.payload.src : '-' }}
                                                    </span>

                                                    <span *ngSwitchCase="'Source Name'">
                                                    {{ element.payload?.src_name ? element.payload.src_name : '-' }}
                                                    </span>

                                                    <span *ngSwitchCase="'MAC'">
                                                    {{ element.payload?.mac ? element.payload.mac : '-' }}
                                                    </span>

                                                    <span *ngSwitchCase="'Destination IP'">
                                                    {{ element.payload?.dst ? element.payload.dst : '-' }}
                                                    </span>

                                                    <span *ngSwitchCase="'Destination Name'">
                                                    {{ element.payload?.dst_name ? element.payload.dst_name : '-' }}
                                                    </span>

                                                    <span *ngSwitchCase="'Protocol'">
                                                    {{ element.payload?.proto_name ? element.payload.proto_name : '-' }}
                                                    </span>

                                                    <span *ngSwitchCase="'Packet'">
                                                    {{ element.payload?.pkt ? element.payload.pkt : 0 }}
                                                    </span>

                                                    <span *ngSwitchCase="'Bytes'">
                                                    {{ element.payload?.byte ? element.payload.byte : 0 }}
                                                    </span>

                                                    <span *ngSwitchCase="'Iface'">
                                                    {{ element.payload?.in_if ? element.payload.in_if :
                                                        (element.payload?.out_if ? element.payload.out_if : '-') }}
                                                    </span>

                                                    <span *ngSwitchCase="'Timestamp'">
                                                    {{ formatDate(element.ts) }}
                                                    </span>

                                                    <span *ngSwitchDefault>-</span>
                                                </ng-container>
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="xdrDisplayedColumns"></tr>
                                            <tr mat-row *matRowDef="let row; columns: xdrDisplayedColumns;"></tr>
                                        </table>
                                        <mat-paginator
                                            [length]="geoipLength"
                                            [pageSize]="geoipPageSize"
                                            [pageSizeOptions]="geoipPageSizeOptions"
                                            (page)="handleGeoipPageEvent($event)"
                                            [hidden]="!geoipSelfSort && !geoipLength">
                                        </mat-paginator>
                                </mat-tab>
                            </mat-tab-group>
                    </section>
                    <section class="example-section">
                        <span class="example-margin">DNSWatch Log</span>
                        <hr class="y-border" />
                                        <span>Selected Profile: {{ getSelectedThreatFeedProfile(2) }}</span>
                        <table mat-table [dataSource]="_dnsDataSource" class="mat-elevation-z8 w-100 d-md-table d-block overflow-auto custom" matSort (matSortChange)="dnsSortData($event)">

                            <ng-container *ngFor="let column of dnsDisplayedColumns; trackBy: trackByFn" [matColumnDef]="column">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column }}</th>
                                <td mat-cell *matCellDef="let element" [ngClass]="stateColor(element.state)">
                                <ng-container [ngSwitch]="column">
                                    <span *ngSwitchCase="'Source'">{{ element.payload?.source ? element.payload.source : '-' }}</span>
                                    <span *ngSwitchCase="'Hostname'">{{ element.payload?.hostname ? element.payload.hostname : '-' }}</span>
                                    <span *ngSwitchCase="'MAC'">{{ element.payload?.mac ? element.payload.mac : '-' }}</span>
                                    <span *ngSwitchCase="'Query'"> {{ element.payload?.query ? element.payload.query : '-' }}</span>
                                    <span *ngSwitchCase="'Pattern'">{{ element.payload?.regex ? element.payload.regex : '-' }}</span>
                                    <span *ngSwitchCase="'Timestamp'">{{ formatDate(element.ts) }}</span>
                                    <span *ngSwitchDefault>-</span>
                                </ng-container>
                                </td>
                            </ng-container>

                        <tr mat-header-row *matHeaderRowDef="dnsDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: dnsDisplayedColumns;"></tr>
                        </table>
                        <mat-paginator 
                            [length]="dnsLength" 
                            [pageSize]="dnsPageSize" 
                            [pageSizeOptions]="dnsPageSizeOptions"
                            (page)="dnsPageEvent = $event" 
                            (page)="handleDnsPageEvent($event)" 
                            [hidden]="!dnsSelfSort && !dnsLength">
                        </mat-paginator>
                    </section>
                </div>                
            </mat-tab>
            <mat-tab label="DOS">
                <hr class="y-border" />
                 <mat-tab-group animationDuration="0ms" class="sub-tab-xdr">                    
                    <mat-tab label="Settings">
                        <hr class="y-border" />
                        <table>
                              <tbody>
                                <tr>
                                    <th width="500px">Enabled</th>                                      
                                    <td>{{ formatEnabled(flowdoscheck_state?.enabled || "") }}</td>                             
                                </tr>
                                <tr>
                                    <th>Report Only</th>     
                                    <td>{{ formatEnabled(flowdoscheck_config?.report_only || "") }}</td>                                    
                                </tr>  
                                <tr>
                                    <th>Sensitivity</th>     
                                    <td>{{ flowdoscheck_config?.mode || "" }}</td>                                    
                                </tr>
                                <tr>
                                    <th>Log file size</th>     
                                    <td>{{ flowdoscheck_config?.log_size || "" }}</td>                                    
                                </tr>
                                <tr>
                                    <th>State CSV file size</th>     
                                    <td>{{ flowdoscheck_config?.state_log_size || "" }}</td>                                    
                                </tr>
                                <tr>
                                    <th>Log Level</th>     
                                    <td>{{ flowdoscheck_config?.log_level || "" }}</td>                                    
                                </tr>
                                <tr>
                                    <th>Check Interval (secs)</th>     
                                    <td>{{ flowdoscheck_config?.interval || "" }}</td>                                    
                                </tr>
                                <tr>
                                    <th>Quarantine Length (secs)</th>     
                                    <td>{{ flowdoscheck_config?.banned_interval || "" }}</td>                                    
                                </tr>
                            </tbody>
                        </table>
                    </mat-tab>
                    <mat-tab label="Quarantined">
                        <hr class="y-border" />
                         <table>
                              <tbody>
                                <tr>
                                    <th width="500px">Blocked Status</th>                                      
                                    <td>{{ formatEnabled(ddos_ipset?.active || "Disabled") }}</td>
                                </tr>
                                <tr>
                                    <th>Total Blocked IPs</th>     
                                    <td>{{ formatDosLength(ddos_ipset?.ddos_quarantine_ip || "" ) }}</td>                                    
                                </tr>  
                                <tr>
                                    <th>Attacker Protocol</th>     
                                    <td>{{ formatBase64(ddos_ipset?.ddos_quarantine_info || "" ) }}</td>                                    
                                </tr>     
                                <tr>
                                    <th>Blocked IPs</th>     
                                    <td>{{ formatBase64(ddos_ipset?.ddos_quarantine_ip || "" ) }}</td>                                    
                                </tr>                            
                            </tbody>
                        </table>
                    </mat-tab>
                    <mat-tab label="Blocked List">
                        <hr class="y-border" />
                        <table>
                              <tbody>
                                <tr>
                                    <th width="500px">Blocked Status</th>                                      
                                    <td>{{ formatEnabled(ddos_ipset?.active || "Disabled") }}</td>
                                </tr>
                                <tr>
                                    <th>Total Blocked IPs</th>     
                                    <td>{{ formatDosLength(ddos_ipset?.ddos_quarantine_ip || "" ) }}</td>                                    
                                </tr>  
                                <tr>
                                    <th>Blocked IPs</th>     
                                    <td>{{ formatBase64(ddos_ipset?.ddos_quarantine_ip || "" ) }}</td>                                    
                                </tr>                               
                            </tbody>
                        </table>
                    </mat-tab>
                    <mat-tab label="Allowed List">
                        <hr class="y-border" />
                        <table>
                              <tbody>
                                <tr>
                                    <th width="500px">Allowed Status</th>                                      
                                    <td>{{ formatEnabled(ddos_ipset?.active || "Disabled") }}</td>
                                </tr>
                                <tr>
                                    <th>Total Allowed IPs</th>     
                                    <td>{{ formatDosLength(ddos_ipset?.ddos_quarantine_ip || "" ) }}</td>                                    
                                </tr>  
                                <tr>
                                    <th>Allowed IPs</th>     
                                    <td>{{ formatBase64(ddos_ipset?.ddos_quarantine_ip || "" ) }}</td>                                    
                                </tr>                               
                            </tbody>
                        </table>
                    </mat-tab>                    
                 </mat-tab-group>                
            </mat-tab>
            <mat-tab label="XDR">
                <div class="pt-4" class="div-wrapper">
                    <section class="example-section">
                        <span class="example-margin">Configuration</span>
                        <hr class="y-border" />
                        <table>
                            <tbody>
                                <tr>
                                    <th width="500px">Status</th>                                      
                                    <td>{{ formatEnabled(xdrConfig?.common?.enabled || "Not Set") }}</td>                             
                                </tr>
                                <tr>
                                    <th>Allow QOS URLs from Class 1-4 and Overlay Steering URLs</th>     
                                    <td>{{ formatEnabled(xdrConfig?.common?.sdwan_ipset || "Not Set") }}</td>                                    
                                </tr>                                             
                            </tbody>
                        </table>
                    </section>
                    <section class="example-section">
                        <span class="example-margin">Threat Feed Groups</span>
                        <hr class="y-border" />
                        <table class="custom">
                            <tbody>
                                <tr>
                                    <th>Group Name</th>
                                    <th># IPs in List</th>                            
                                    <th>Local # IPs/Subnets</th>
                                    <th>Enabled</th>
                                    <th>Profile</th>
                                    <th>Version</th>
                                    <th>Last Update</th>
                                </tr>
                                <tr *ngFor="let feed of xdrConfig.threat_feed">
                                    <td>{{ feed.name }}</td>
                                    <td>{{ feed.ip_cnt }}</td>                            
                                    <td>{{ feed.local_ip_cnt }}</td>
                                    <td>{{ formatEnabled(feed.enabled) }}</td>
                                    <td>{{ feed.profile }}</td>   
                                    <td>{{ feed.version }}</td>
                                    <td>{{ formatDate(feed.update_ts) }}</td>
                                </tr>                                             
                            </tbody>
                        </table>
                    </section>
                    <section class="example-section">
                        <span class="example-margin">GeoIP Filtering</span>
                        <hr class="y-border" />
                        <table class="custom">
                              <tbody>
                                <tr>
                                    <th width="300px">Status</th>
                                    <td>{{ formatEnabled(xdrConfig?.geoip?.enabled || "Not Set") }}</td>
                                </tr>
                                <tr>
                                    <th width="300px">GeoIP Blocklist</th>
                                    <td class="table-clean">                                        
                                        <table>
                                        <tr>
                                            <th>Continent</th>
                                            <th>Country</th>
                                            <th>State</th>
                                            <th>City</th>
                                        </tr>
                                        <tr  *ngFor="let list of xdrConfig?.geoip?.blocklist">
                                            <td>{{ formatLocation(list,'continent') }}</td>
                                            <td>{{ formatLocation(list,'country') }}</td>
                                            <td>{{ formatLocation(list,'state') }}</td>
                                            <td>{{ formatLocation(list,'city') }}</td>
                                        </tr>         
                                        </table>                                               
                                    </td>
                                </tr>
                                 <tr>
                                    <th width="300px">GeoIP Allowlist</th>
                                    <td class="table-clean">                                      
                                        <table>
                                            <tr>
                                                <th>Continent</th>
                                                <th>Country</th>
                                                <th>State</th>
                                                <th>City</th>
                                            </tr>
                                            <tr  *ngFor="let list of xdrConfig?.geoip?.allowlist">
                                                <td>{{ formatLocation(list,'continent') }}</td>
                                                <td>{{ formatLocation(list,'country') }}</td>
                                                <td>{{ formatLocation(list,'state') }}</td>
                                                <td>{{ formatLocation(list,'city') }}</td>
                                            </tr>                                                        
                                        </table>
                                    </td>
                                </tr>      
                            </tbody>
                        </table>
                    </section>
                    <section class="example-section">
                        <span class="example-margin">DNS/URL Content Filtering - Custom</span>
                        <hr class="y-border" />
                        <table class="custom">
                              <tbody>
                                <tr>
                                    <th width="300px">Status</th>
                                    <td>{{ formatEnabled(xdrConfig?.dnswatch?.enabled || "Not Set") }}</td>
                                </tr>
                                  <tr>
                                    <th width="300px">DNS/URL Blocklist</th>
                                    <td>
                                        <table class="custom">
                                            <tr>
                                                <th>Host of a Sub-domain</th>
                                                <th>Sub-domain or Host</th>
                                                <th>Domain</th>
                                                <th>Extension (.com | .net | .org)</th>
                                            </tr>
                                            <tr *ngFor="let list of xdrConfig?.dnswatch?.blocklist">
                                                <td>{{ formatDomain(list,'host') }}</td>
                                                <td>{{ formatDomain(list,'subdomain') }}</td>
                                                <td>{{ formatDomain(list,'domain') }}</td>
                                                <td>{{ formatDomain(list,'ext') }}</td>
                                            </tr>                                                        
                                        </table>
                                             
                                    </td>
                                </tr>
                                 <tr>
                                    <th width="300px">DNS/URL Allowlist</th>
                                    <td>                                        
                                        <table class="custom">
                                            <tr>
                                                <th>Host of a Sub-domain</th>
                                                <th>Sub-domain or Host</th>
                                                <th>Domain</th>
                                                <th>Extension (.com | .net | .org)</th>
                                            </tr>
                                            <tr  *ngFor="let list of xdrConfig?.dnswatch?.allowlist">
                                                <td>{{ formatDomain(list,'host') }}</td>
                                                <td>{{ formatDomain(list,'subdomain') }}</td>
                                                <td>{{ formatDomain(list,'domain') }}</td>
                                                <td>{{ formatDomain(list,'ext') }}</td>
                                            </tr>                                                        
                                        </table>                                               
                                    </td>
                                </tr>                                              
                            </tbody>
                        </table>
                    </section>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>

